window.onload = function () {
  
   
  setTimeout(function () {
    var fbtVar = $(".fbt-vars-price");

    let axtBundlePrice = 0;
    let axtBundlePriceOriginal = 0;
    let CurrencyCode = "";

    for (let i = 0; i < fbtVar.length; i++) {
      let axtOriginalPrice = $(".fbt-vars-price:eq(" + i + ")")
        .find(".product-price")
        .find(".axt-cp-custom")
        .find(".axt_show_original")
        .text()
        .split(" ");
      
      if (axtOriginalPrice.length == 1) {
        axtOriginalPrice = $(".fbt-vars-price:eq(" + i + ")")
          .find(".product-price")
          .find(".axt-cp-custom")
          .siblings(".axt-compare-at-price")
          .text()
          .split(" ");
      }

      if (
        $(".fbt-vars-price:eq(" + i + ")")
          .find(".product-price")
          .find(".axt-cp-custom")
          .find(".axt_discounted_price")
          .text()
      ) {
        var axtDiscountedPrice = $(".fbt-vars-price:eq(" + i + ")")
          .find(".product-price")
          .find(".axt-cp-custom")
          .find(".axt_discounted_price")
          .text()
          .split(" ");
        CurrencyCode = axtDiscountedPrice[0];

         
        if(axtDiscountedPrice[1] && axtDiscountedPrice[1]!=""){
            axtBundlePrice += parseFloat(axtDiscountedPrice[1]);
        }
      } else {
        var axtDiscountedPrice = $(".fbt-vars-price:eq(" + i + ")")
          .find(".product-price").find(".axt-cp-custom")
          .text()
          .split(" ");
        CurrencyCode = axtDiscountedPrice[0];
         
        if(axtDiscountedPrice[1] && axtDiscountedPrice[1]!=""){
            axtBundlePrice += parseFloat(axtDiscountedPrice[1]);
        }
      }

      if(axtOriginalPrice[1] && axtOriginalPrice[1]!=""){
        axtBundlePriceOriginal += parseFloat(axtOriginalPrice[1]);
      }
    }

    if (
      axtBundlePrice != null &&
      axtBundlePrice != 0 &&
      axtBundlePrice != "NaN"
    ) {
      document.getElementById("axt-bundle-price").innerText =
        CurrencyCode + " " + axtBundlePrice.toFixed(2);
    }

    if (
      axtBundlePriceOriginal != null &&
      axtBundlePriceOriginal != 0 &&
      axtBundlePriceOriginal != "NaN"
    ) {
      document.getElementById("axt-bundle-price-original").style.display = null;
      document.getElementById("axt-bundle-price-original").innerText =
        CurrencyCode + " " + axtBundlePriceOriginal.toFixed(2);
    }


    let bundlePriceBckup = parseFloat($("#axt-bundle-price").text().split(" ")[1]);
    
    
    $(".axtCheckboxProduct").click(function () {

      let bundlePrice = parseFloat($("#axt-bundle-price").text().split(" ")[1]);
    console.log(bundlePrice);
      
      var axtDiscountedPrice = $(this)
        .siblings(".fbt-vars-price")
        .find(".axt_discounted_price")
        .text();
      var currency = axtDiscountedPrice.split(" ")[0];
      var amount = axtDiscountedPrice.split(" ")[1];

      if ($(this).prop("checked") == true) {
        //console.log("Checkbox is checked.");

        var bundlePriceUpdated = parseFloat(bundlePrice) + parseFloat(amount);
        
        if (parseFloat(bundlePriceUpdated) && (bundlePrice < bundlePriceBckup)) {
           
          $("#axt-bundle-price").text(
            CurrencyCode + " " + parseFloat(bundlePriceUpdated).toFixed(2)
          );
        }
        
      }

      if ($(this).prop("checked") == false) {
        //console.log("Checkbox is unchecked.");

        var bundlePriceUpdated = parseFloat(bundlePrice) - parseFloat(amount);
        if (parseFloat(bundlePriceUpdated)) {
           

          $("#axt-bundle-price").text(
            CurrencyCode + " " + parseFloat(bundlePriceUpdated).toFixed(2)
          );
        }
      }
    });
  }, 5000);
};
